import classNames from "classnames/bind";
import { useEffect, useRef, useState, useCallback } from "react";
import styles from './InputGroup.module.css';
import PropTypes from "prop-types";

const cx = classNames.bind(styles);

function InputGroup({ onGetCode, error }) {
    const [focus, setFocus] = useState(0)
    const [data, setData] = useState(new Array(6).fill(""))

    const refInput = useRef(null)

    // console.log('focus', focus);


    const handeChange = (index, e) => {
        // console.log("e", e);

        let newOtp = [...data];
        newOtp[index] = e.substring(e.length - 1)
        setData(newOtp)
    }

    const handleKeyup = (e, i) => {
        //     // console.log('e key up', e, i);
        //     if (e.code === 'Backspace' && focus > 0) {
        //         setFocus(i - 1);
        //     } else if (e.code !== 'Backspace' && e.code !== 'KeyV' && focus >= 0 && e.target?.value?.trim()?.length > 0) {
        //         setFocus(i + 1)
        //     }
    }

    // console.log('data', data);

    useEffect(() => {
        refInput.current?.focus()
    }, [focus])

    const validateToken = useCallback(async (token) => {
        const stringToken = token?.join('');
        const numberToken = Number(stringToken);
        await onGetCode(numberToken)
    }, [])

    useEffect(() => {
        if (data.length === 6 && data[5] !== '') {
            validateToken(data)
        }
    }, [data, validateToken])

    return (
        <div className={cx('input-small-group')}>
            {data.map((item, index) => {
                return (
                    <input
                        key={index}
                        ref={index === focus ? refInput : null}
                        onChange={(e) => handeChange(index, e.target.value)}
                        value={item[index]}
                        maxLength={1}
                        placeholder={'-'}
                        autoFocus={index === 0}
                        className={cx('input-small', error ? 'error' : '')}
                        onKeyUp={e => handleKeyup(e, index)}
                        type="number"
                    // onKeyDown={e => handleKeyup(e, index)}
                    />)
            })}

        </div>
    )
}

InputGroup.propTypes = {
    onGetCode: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
};
export default InputGroup;